/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const ProjectEntityHeader = ({ entityTitle }: { entityTitle?: string }) => {
  const props = entityTitle ? { entityTitle } : { entityTitleSource: 'name' };

  return <EntityHeader {...props} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default ProjectEntityHeader;
